import * as React from 'react';
import { PageDescription } from './PageDescription';
import { FacebookMeta } from './FacebookMeta';
import { OpenGraph } from './OpenGraph';
import { TwitterShare } from './TwitterShare';
import { GoogleNewsSchema } from './GoogleNewsSchema';
import { createImageAttributes, PageImage } from './metaTags.utils';
import { RobotsMeta } from './RobotsMeta';

interface PostMetaHeaderTagsProps {
  canonicalUrl: string;
  favicon: string;
  pageDescription: string;
  facebookAppId: string | null;
  facebookPageId: string | null;
  pageTitle: string;
  twitterAccount: string | null;
  siteName: string;
  pageImage: PageImage;
  logoUrl: string;
  authors: { name: string }[];
  createdAt: string;
  updatedAt: string;
  noIndex: boolean;
  ampURL: string | null;
  prevCanonicalUrl: string | null;
  ogDescription: string;
  ogTitle: string;
  ogImage: PageImage;
  twitterDescription: string;
  twitterTitle: string;
  twitterImage: PageImage;
}

export const PostMetaHeaderTags: React.FunctionComponent<PostMetaHeaderTagsProps> = props => {
  const {
    canonicalUrl,
    favicon,
    pageDescription,
    facebookAppId,
    facebookPageId,
    pageTitle,
    twitterAccount,
    siteName,
    pageImage,
    logoUrl,
    authors,
    createdAt,
    updatedAt,
    noIndex,
    ampURL,
    prevCanonicalUrl,
    ogDescription,
    ogImage,
    ogTitle,
    twitterDescription,
    twitterImage,
    twitterTitle,
  } = props;
  const pageImageUrl = createImageAttributes(pageImage).imageUrl;
  const facebookImageProperties = createImageAttributes(ogImage);
  const twitterImageProperties = createImageAttributes(twitterImage);
  return (
    <React.Fragment>
      <PageDescription
        pageUrl={canonicalUrl}
        favicon={favicon}
        description={pageDescription}
        title={pageTitle}
        ampURL={ampURL}
        prevCanonicalUrl={prevCanonicalUrl}
      />
      <FacebookMeta appId={facebookAppId} pageId={facebookPageId} />
      <OpenGraph
        pageUrl={canonicalUrl}
        image={facebookImageProperties.imageUrl}
        title={ogTitle}
        siteName={siteName}
        imageHeight={facebookImageProperties.imageHeight}
        imageWidth={facebookImageProperties.imageWidth}
        description={ogDescription}
      />
      <TwitterShare
        title={twitterTitle}
        description={twitterDescription}
        account={twitterAccount}
        image={twitterImageProperties.imageUrl}
        pageUrl={canonicalUrl}
        imageHeight={twitterImageProperties.imageHeight}
        imageWidth={twitterImageProperties.imageWidth}
      />
      <GoogleNewsSchema
        canonical={canonicalUrl}
        title={pageTitle}
        image={pageImageUrl}
        datePublished={createdAt}
        dateModified={updatedAt}
        authors={authors}
        publisherName={siteName}
        logoUrl={logoUrl}
      />
      <RobotsMeta noIndex={noIndex} />
    </React.Fragment>
  );
};
